module.exports = __webpack_public_path__ + "static/media/js&ts&html&css.72d9984c.svg";